import apiClient from '../lib/api-client';

export type ImportJobStatus = 'queued' | 'processing' | 'completed' | 'failed';

export interface ImportJobError {
  row: number;
  error: string;
  data: Record<string, unknown>;
}

// Dạng toSummary() của api/import-jobs (EBD-62)
export interface ImportJob {
  id: string;
  kind: string;
  status: ImportJobStatus;
  progress: number;
  file_name: string;
  total_rows: number;
  processed_rows: number;
  success_rows: number;
  error_rows: number;
  created_accounts: number;
  message: string | null;
  queue_stuck: boolean;
  created_at?: string | null;
  errors?: ImportJobError[];
}

const saveBlob = (data: BlobPart, fileName: string) => {
  const url = window.URL.createObjectURL(new Blob([data]));
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', fileName);
  document.body.appendChild(link);
  link.click();
  link.remove();
  window.URL.revokeObjectURL(url);
};

class ImportJobService {
  private baseUrl = '/import-jobs';

  async startActivation(file: File): Promise<ImportJob> {
    const formData = new FormData();
    formData.append('kind', 'activations');
    formData.append('file', file);

    const response = await apiClient.post(this.baseUrl, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
    return response.data.data;
  }

  // id lấy từ ?job= trên URL: chỉ nhận dạng id, để "../x" (kể cả %2e%2e) không thành đường dẫn API khác
  private jobUrl(id: string): string {
    if (!/^[\w-]+$/.test(id)) {
      throw new Error('Mã lần kích hoạt không hợp lệ');
    }
    return `${this.baseUrl}/${id}`;
  }

  // Job kích hoạt gần đây của chính admin đang đăng nhập, để vào lại từ menu vẫn thấy job đang chạy
  async listActivations(limit = 5): Promise<ImportJob[]> {
    const response = await apiClient.get(this.baseUrl, { params: { kind: 'activations', limit } });
    return response.data.data;
  }

  async get(id: string): Promise<ImportJob> {
    const response = await apiClient.get(this.jobUrl(id));
    return response.data.data;
  }

  // Tải qua apiClient để kèm token: link thẳng tới API sẽ bị 401
  async downloadReport(id: string): Promise<void> {
    const response = await apiClient.get(`${this.jobUrl(id)}/report`, { responseType: 'blob' });
    saveBlob(response.data, `loi-kich-hoat-${id}.csv`);
  }

  async downloadAccounts(id: string): Promise<void> {
    const response = await apiClient.get(`${this.jobUrl(id)}/accounts`, { responseType: 'blob' });
    saveBlob(response.data, `tai-khoan-kich-hoat-${id}.csv`);
  }
}

const importJobService = new ImportJobService();
export default importJobService;
